// extracted by mini-css-extract-plugin
export default {"footerNav":"footerNav--mEeOQ","footerNavWrapper":"footerNavWrapper--qkhph","footerCopyright":"footerCopyright--KcTu2"};